import React from "react";
import { useEffect, useContext,useState } from "react";

import { Box, Button, Typography } from "@mui/material";
import logo from "../images/itaam-company-2.png";
import { useNavigate } from "react-router-dom";
import { HeaderContext } from "../App";
import { jwtDecode } from "jwt-decode";

const PetServicePage = () => {
  const navigate = useNavigate();
  const { setTitle, setShowBack } = useContext(HeaderContext);

  const accessToken = localStorage.getItem("accessToken");
  const [name, setName] = useState("");

  useEffect(() => {
    if (!accessToken) {
      navigate("/auth/login");
      return;
    }
    try {
      const decoded = jwtDecode(accessToken);
      setName(`${decoded.title} ${decoded.name} ${decoded.lastname}`);
    } catch (err) {
      console.error("Invalid access token:", err);
      navigate("/auth/login");
    }
  }, [accessToken, navigate]);
  useEffect(() => {
    setTitle("บริการ");
    // setShowBack(true);

    return () => {
      setTitle("Bow HIS.");
      setShowBack(false);
    };
  }, [setTitle, setShowBack]);

  const handleVaccineClick = () => {
    navigate("/search/pet?service=vaccine");
  };

  const handleMicrochipClick = () => {
    navigate("/search/pet?service=chip");
  };

  return (
    <Box
      sx={{
        height: "90vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f5f5",
        gap: 4,
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
        ยินดีต้อนรับ
      </Typography>
      <Typography variant="h5">
        {name}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        บริการสัตวแพทย์
      </Typography>
      <Box
        sx={{
          width: 230, // ปรับขนาดตามต้องการ
          height: 200,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          mb: 2,
        }}
      >
        <img
          src={logo} // ใส่ path รูปของคุณ
          alt="Logo"
          style={{ width: "100%", height: "100%" }}
        />
      </Box>

      <Button
        variant="contained"
        onClick={handleVaccineClick}
        sx={{
          width: 250,
          height: 60,
          fontSize: 18,
          fontWeight: "bold",
          color: "#fff",
          background: "linear-gradient(90deg, #ef771e 0%, #e04b22 100%)",
          "&:hover": {
            background: "linear-gradient(90deg, #e04b22 0%, #ef771e 100%)",
          },
        }}
      >
        ฉีดวัคซีน
      </Button>

      <Button
        variant="contained"
        onClick={handleMicrochipClick}
        sx={{
          width: 250,
          height: 60,
          fontSize: 18,
          fontWeight: "bold",
          color: "#fff",
          background: "linear-gradient(90deg, #3a7bd5 0%, #00d2ff 100%)",
          "&:hover": {
            background: "linear-gradient(90deg, #00d2ff 0%, #3a7bd5 100%)",
          },
        }}
      >
        ฝังไมโครชิพ
      </Button>
    </Box>
  );
};

export default PetServicePage;
